import { render, staticRenderFns } from "./ResultViewNew.vue?vue&type=template&id=7fc71310&scoped=true&"
import script from "./ResultViewNew.vue?vue&type=script&lang=js&"
export * from "./ResultViewNew.vue?vue&type=script&lang=js&"
import style0 from "./ResultViewNew.vue?vue&type=style&index=0&id=7fc71310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc71310",
  null
  
)

export default component.exports